export var SET_EVENTS_COLLECTIONS = '@events/SET_EVENTS_COLLECTIONS';
export var FETCH_COLLECTION_SCHEMA = '@events/FETCH_COLLECTION_SCHEMA';
export var FETCH_COLLECTION_SCHEMA_SUCCESS = '@events/FETCH_COLLECTION_SCHEMA_SUCCESS';
export var FETCH_COLLECTION_SCHEMA_ERROR = '@events/FETCH_COLLECTION_SCHEMA_ERROR';
export var SET_COLLETION_SCHEMA_LOADING = '@events/SET_COLLETION_SCHEMA_LOADING';
export var SCHEMA_COMPUTED = '@events/SCHEMA_COMPUTED';